import type { ReactNode } from 'react';
import { FilterProvider } from '@/context';
import type { InitialState } from '@/test/setup/types';

type CombinedProvidersProps = {
  children: ReactNode;
  value?: InitialState;
};

const CombinedProviders = ({ children, value }: CombinedProvidersProps) => (
  <FilterProvider initialState={value?.filter}>{children}</FilterProvider>
);

export default CombinedProviders;
